import * as React from 'react';

function SvgMenuUp(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M7.646 15.854a.5.5 0 00.708 0L10.207 14H14a2 2 0 002-2V3a2 2 0 00-2-2H2a2 2 0 00-2 2v9a2 2 0 002 2h3.793l1.853 1.854zM1 9V6h14v3H1zm14 1v2a1 1 0 01-1 1h-3.793a1 1 0 00-.707.293l-1.5 1.5-1.5-1.5A1 1 0 005.793 13H2a1 1 0 01-1-1v-2h14zm0-5H1V3a1 1 0 011-1h12a1 1 0 011 1v2zM2 11.5a.5.5 0 00.5.5h8a.5.5 0 000-1h-8a.5.5 0 00-.5.5zm0-4a.5.5 0 00.5.5h11a.5.5 0 000-1h-11a.5.5 0 00-.5.5zm0-4a.5.5 0 00.5.5h6a.5.5 0 000-1h-6a.5.5 0 00-.5.5z' />
		</svg>
	);
}

export default SvgMenuUp;
